import React, { useEffect, useState } from "react";
import { ShoppingBag, X } from "lucide-react";

// Rotating mock notifications — replace with real-time webhook feed when order volume picks up
const NOTIFICATIONS = [
  { who: "Marcus T.", what: "$99.99 Content Pack", where: "Austin, TX", when: "3 minutes ago" },
  { who: "Lena R.", what: "Monthly Plan", where: "Brooklyn, NY", when: "11 minutes ago" },
  { who: "Devon K.", what: "$99.99 Content Pack", where: "Miami, FL", when: "27 minutes ago" },
  { who: "Priya S.", what: "Monthly Plan", where: "Seattle, WA", when: "42 minutes ago" },
  { who: "Jordan W.", what: "$99.99 Content Pack", where: "Chicago, IL", when: "1 hour ago" },
  { who: "Alex M.", what: "Monthly Plan", where: "Denver, CO", when: "2 hours ago" },
];

export const SocialProofToast = () => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    // Wait 8 seconds before first toast, then cycle every 14s
    const first = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(first);
  }, [dismissed]);

  useEffect(() => {
    if (dismissed || !visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % NOTIFICATIONS.length);
        setVisible(true);
      }, 600);
    }, 14000);
    return () => clearInterval(cycle);
  }, [visible, dismissed]);

  if (dismissed) return null;
  const n = NOTIFICATIONS[idx];

  return (
    <div
      className={`fixed bottom-4 left-4 z-40 max-w-xs transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="social-proof-toast"
    >
      <div className="snap-card p-4 flex items-start gap-3 shadow-[0_10px_50px_rgba(0,0,0,0.5)]">
        <div className="w-10 h-10 rounded-full bg-[#3B9EFF]/15 border border-[#3B9EFF]/40 flex items-center justify-center text-[#3B9EFF] shrink-0">
          <ShoppingBag size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm leading-tight">
            <span className="font-bold">{n.who}</span> just ordered{" "}
            <span className="text-[#3B9EFF]">{n.what}</span>
          </p>
          <p className="text-[#A0AABF] text-xs mt-1">
            {n.where} · {n.when}
          </p>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          data-testid="social-proof-dismiss"
          className="text-[#A0AABF] hover:text-white"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SocialProofToast;
